import React from "react";

// SSR CopperX brand mark
// Uses the official client-provided PNG assets:
// - /brand/ssr-logo.png (SSR red/blue mark)
// - /brand/copperx-logo.png (Official COPPERX wordmark with hex-O icon and extended X tail)
export default function Logo({ variant = "dark", className = "", showSSR = true }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      {showSSR && (
        <img
          src="/brand/ssr-logo.png"
          alt="SSR"
          className="h-9 w-auto object-contain shrink-0"
          style={{ maxHeight: 36 }}
        />
      )}
      <img
        src="/brand/copperx-logo.png"
        alt="CopperX"
        className="h-7 md:h-8 w-auto object-contain"
        style={{ maxHeight: 32, filter: variant === "light" ? "brightness(1.1)" : "none" }}
      />
    </div>
  );
}
